import { IStressResponse } from '../../interfaces/pos-risk/stress.interface';

export class Stress {


    public dayTradeStress: number;
    public strategyStress: number;
    public defaultSress: number;
    public instrument: string;
    public isPtax: boolean;

    constructor(stressObject: IStressResponse){
        this.dayTradeStress = stressObject.dayTradeValue;
        this.strategyStress = stressObject.dayTradeStrategyValue;
        this.defaultSress = stressObject.value;
        this.instrument = stressObject.instrument;
        this.isPtax = stressObject.isPtax ? stressObject.isPtax : false;
    }

}